import { render } from "./armazemEstoque.vue?vue&type=template&id=0a205285"
import script from "./armazemEstoque.vue?vue&type=script&lang=js"
export * from "./armazemEstoque.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__